<template>
  <div class="main-wrapper scroll-y custom-scrollbar with-tabs view-user-employees">

    <page-title :title="'Twoi pracownicy'" :back="true"></page-title>

    <div v-for="(item,index) in employees" :key="item.slug">
      <item-user-employee
          :index="index+1"
          :employee_id="item.employee_id"
          :first_name="item.first_name"
          :last_name="item.last_name"
          :badge="item.badge"
          :roles="item.roles">
      </item-user-employee>
    </div>

    <slide-y-up-transition :duration="400" :delay="200">
      <p v-if="show && employees.length === 0" class="text-center">Nie masz jeszcze żadnych pracowników.</p>
    </slide-y-up-transition>

    <slide-y-up-transition :duration="400" :delay="300">
      <ion-button v-if="show && (last_page > page)"
                  mode="ios"
                  expand="block"
                  class="mb-10"
                  @click="loadMore"
                  :disabled="loading">
        <span v-if="loading"><span class="loader"></span></span>
        <span v-else>Załaduj więcej</span>
      </ion-button>
    </slide-y-up-transition>

  </div>
</template>

<script>
import {mapState} from 'vuex';
import PageTitle from '@/components/PageTitle.vue';
import ItemUserEmployee from '@/items/ItemUserEmployee';

export default {
  name: 'UserEmployees',
  components: {PageTitle, ItemUserEmployee},
  data() {
    return {
      show: false
    }
  },
  computed: {
    ...mapState({
      loading: state => state.employees.loading,
      employees: state => state.employees.data,
      page: state => state.employees.page,
      last_page: state => state.employees.last_page
    })
  },
  mounted() {
    this.show = true;
    this.getEmployees();
  },
  methods: {
    getEmployees() {
      this.$store.dispatch('employees/USER_EMPLOYEES_REQUEST')
    },
    loadMore() {
      this.$store.dispatch('employees/USER_EMPLOYEES_SET_PAGE', false).then(() => {
        this.getEmployees();
      })
    }
  }
}
</script>

<style lang="scss" scoped>
ion-card-content {
  padding: 8px 12px;
}
</style>